var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 24 24",
    id: "Interface-Essential-Information-Circle-1--Streamline-Pixel.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Interface Essential Information Circle 1 Streamline Icon: https://streamlinehq.com")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "interface-essential-information-circle-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9075 8.7615625H23v5.476875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8078125 14.2384375h1.0996875v2.1921874999999997h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8078125 6.569375000000001h1.0996875v2.1921874999999997h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7153125 16.430625h1.0925v2.185h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7153125 4.3771875h1.0925v2.1921874999999997h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.615624999999998 18.615624999999998h1.0996875v1.0996875H18.615624999999998Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.615624999999998 3.2846875000000004h1.0996875v1.0925H18.615624999999998Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.430625 19.7153125h2.185v1.0925h-2.185Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.430625 2.1921874999999997h2.185v1.0925h-2.185Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2384375 20.8078125h2.1921874999999997v1.0996875h-2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.3309375 16.430625 -1.0925 0 0 -5.476875 -1.0925 0 0 -1.0996875 -3.291875 0 0 1.0996875 -1.0925 0 0 7.661875 1.0925 0 0 1.0996875 5.476875 0 0 -1.0996875 1.0996875 0 0 -1.0925 -1.0996875 0 0 -1.0925z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2384375 1.0925h2.1921874999999997v1.0996875h-2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7615625 21.9075h5.476875V23h-5.476875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.854062500000001 8.7615625 3.291875 0 0 -1.0925 1.0925 0 0 -3.291875 -1.0925 0 0 -1.0925 -3.291875 0 0 1.0925 -1.0925 0 0 3.291875 1.0925 0 0 1.0925z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7615625 0h5.476875v1.0925h-5.476875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.569375000000001 20.8078125h2.1921874999999997v1.0996875H6.569375000000001Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.569375000000001 1.0925h2.1921874999999997v1.0996875H6.569375000000001Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3771875 19.7153125h2.1921874999999997v1.0925H4.3771875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3771875 2.1921874999999997h2.1921874999999997v1.0925H4.3771875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2846875000000004 18.615624999999998h1.0925v1.0996875H3.2846875000000004Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2846875000000004 3.2846875000000004h1.0925v1.0925H3.2846875000000004Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1921874999999997 16.430625h1.0925v2.185H2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1921874999999997 4.3771875h1.0925v2.1921874999999997H2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0925 14.2384375h1.0996875v2.1921874999999997H1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0925 6.569375000000001h1.0996875v2.1921874999999997H1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.7615625h1.0925v5.476875H0Z",
    fill: "#000000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.6595fff682979fd644d46730f631dabc.svg";
export { ForwardRef as ReactComponent };